import { render } from "./HospiceTransferForm.vue?vue&type=template&id=b73f1f5a"
import script from "./HospiceTransferForm.ts?vue&type=script&lang=js&external"
export * from "./HospiceTransferForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__